import React, { useEffect, useRef, useState } from "react";
import styles from "./ContactUs.module.css";
import { Form, Input, Button, DatePicker, TimePicker, Select, message, Spin } from "antd";
import MapSection from "./MapSection";
import useWindowWidth from "helpers/useWindowWidth";
import { API_BASE_URL } from "configs/AppConfig";
import moment from 'moment';
import MetaDetails from "components/meta-details/MetaDetails";
import SEO from "components/SEO/SEO";
import { useSelector } from "react-redux";

function ContactUs() {
  const { TextArea } = Input;
  const [containerHeight, setContainerHeight] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const width = useWindowWidth();
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();
  const curRef = useRef();
  const { settings } = useSelector((state) => state.constants);

  const onFinish = async () => {
    try {
      // Trigger form validation
      const values = await form.validateFields();
      console.log('form values', values)
  
      setLoading(true);
  
      // Format date and time values if they exist
      if (values?.preferableDate) {
        values.preferableDate = values.preferableDate
          ? values.preferableDate.format("DD-MM-YYYY")
          : null;
      }
      if (values?.preferableTime) {
        values.preferableTime = values.preferableTime
          ? values.preferableTime.format("hh:mm A")
          : null;
      }
  
      // Make the API request
      const response = await fetch(`${API_BASE_URL}contact-us/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values), // Convert request body to JSON string
      });
  
      
      if (!response.ok) {
        throw new Error("Failed to submit the form");
      }
  
      const data = await response.json();
      console.log("Success:", data);
      message.success("Submitted Successfully");
      form.resetFields();
      setLoading(false);
    } catch (error) {
      // Show error message if validation fails or an API error occurs
      console.error("Error:", error);
      if (error.name === "Error") {
        message.error("Please enter all required fields correctly!");
      } else {
        message.error("Please enter all required fields");
      }
      setLoading(false);
    }
  };
  

  useEffect(() => {
    const height = curRef?.current?.offsetHeight;
    setContainerHeight(height);
  }, [curRef]);
  console.log(SEO,'contact SEO')
  return (
    <>
   <SEO  />
    <MetaDetails
        title={"Contact Us"}
        description={"Contact us"}
        keywords={["Contact Us","Contact"]?.join(', ')}
      />
    <div className="contact-uss">
    <div className={styles.contactOuter}>
      <div className={styles.container}>
        <div
          className={styles.contactUs}
          style={{
            height:
              width > 1400 ? containerHeight : width > 700 ? "200px" : "150px",
          }}
        >
          CONTACT US
        </div>
        <div data-aos="fade-left"  ref={curRef} className={styles.infoContainer}>
          <div className={styles.headerContainer}>
            <div className={styles.tellUsAboutYou}>TELL US ABOUT YOU</div>
            <div className={styles.ourSupport}>Our Support</div>
          </div>
          <div className={styles.description}>
            We shall send you a scope of work as soon as we receive your
            request.
          </div>
          <div className={styles.addressContainer}>
            <div className={styles.address}>
              {settings?.address && (
                <p style={{width: '280px', marginBottom: 0}}>
              Address: {settings?.address}
              </p>)}
              <br />
              {settings?.contactNumber && (
              `Phone: ${settings?.contactNumber}` )}<br />
              {settings?.email && (
              `Email: ${settings?.email}` )}
            </div>
            <img
              loading="lazy"
              src="/img/bodyshop/down-incline-arrow.svg"
              className={styles.icon}
              alt="Contact icon"
            />
          </div>
        </div>
      </div>
      <section className={styles.container}>
        <header data-aos="fade-right" className={styles.headerSection}>
          <h1 className={styles.title}>Request Service</h1>
          <p className={styles.description}>
            Reach us with your queries. We will be happy to assist you.
          </p>
          <img
            loading="lazy"
            src="/img/bodyshop/right-blue-arrow.svg"
            className={styles.icon2}
            alt=""
          />
        </header>
        <Form
          form={form}
          name="requestService"
          // onFinish={onFinish}
          layout="vertical"
          className={styles.formContainer}
          data-aos="fade-up"
        >
          <div className={styles.formContent}>
            <div className={styles.formSection}>
              <div className={styles.formRow}>
                <Form.Item
                  name="name"
                  label="First Name"
                  rules={[
                    { required: true, message: "Please input your first name!" },
                  ]}
                  className={styles.formField}
                >
                  <Input
                    style={{ width: width > 700 ? "100%" : "100%" }}
                    placeholder="Name"
                    className={styles.inputField}
                  />
                </Form.Item>
                <Form.Item
                  name="lastName"
                  label="Last Name"
                  // rules={[
                  //   { required: true, message: "Please input your last name!" },
                  // ]}
                  className={styles.formField}
                >
                  <Input
                    style={{ width: width > 700 ? "100%" : "100%" }}
                    placeholder="Name"
                    className={styles.inputField}
                  />
                </Form.Item>
              </div>
              <Form.Item
                name="address"
                label="Address"
                // rules={[
                //   { required: true, message: "Please input your address!" },
                // ]}
                className={styles.addressField}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Address"
                  className={styles.inputField}
                />
              </Form.Item>
              <div className={styles.formRow}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: true, message: "Please input your email!" },
                    { type: "email", message: "Please enter a valid email!" },
                  ]}
                  className={styles.formField}
                >
                  <Input placeholder="Email" className={styles.inputField} />
                </Form.Item>
                <Form.Item
                  name="phoneNumber"
                  label="Phone Number"
                  rules={[
                    {
                      required: true,
                      message: "Please input your phone number!",
                    },
                  ]}
                  className={styles.formField}
                >
                  <Input
                    placeholder="Phone Number"
                    className={styles.inputField}
                    type="number"
                  />
                </Form.Item>
              </div>
              <div className={styles.formRow}>
                <Form.Item
                  name="preferableDate"
                  label="Preferable Date"
                  // rules={[{ required: true, message: "Please select a date!" }]}
                  className={styles.formField}
                >
                  <DatePicker
                    className={styles.dateTimeField}
                    format="DD-MM-YYYY"
                  />
                </Form.Item>
                <Form.Item
                  name="preferableTime"
                  label="Preferable Time"
                  // rules={[{ required: true, message: "Please select a time!" }]}
                  className={styles.formField}
                >
                  <TimePicker className={styles.dateTimeField} format="HH:mm" />
                </Form.Item>
              </div>
              <Form.Item
                name="typeOfService"
                label="Type of service"
                // rules={[
                //   { required: true, message: "Please select a service type!" },
                // ]}
                className={styles.formField}
              >
                <Input
                    placeholder="Type of service"
                    className={styles.inputField}
                  />
              </Form.Item>
              <Form.Item
                name="message"
                label="Message"
                // rules={[
                //   { required: true, message: "Please input your message!" },
                // ]}
                className={styles.messageField}
              >
                <TextArea
                  rows={4}
                  placeholder="Your message"
                  className={styles.messageInput}
                />
              </Form.Item>
            </div>
            <Form.Item>
              <button
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                type="primary"
                htmlType="submit"
                onClick={onFinish}
                className={
                  isHovered ? styles.submitButtonHovered : styles.submitButton
                }
              >
                {loading ? <Spin size="large" /> : "Send Message"}
              </button>
            </Form.Item>
          </div>
        </Form>
      </section>

      <MapSection settings={settings} />
    </div>
    </div>
    </>
  );
}

export default ContactUs;
